/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const QueueStatsFilterTypeDefinitionKey = {
  Country: 'country',
  PricingPlan: 'pricingPlan',
  RequiredSkills: 'requiredSkills',
  DeviceBrand: 'deviceBrand',
  DeviceAppName: 'deviceAppName',
  DeviceOsVersion: 'deviceOsVersion',
  DeviceClientAppVersion: 'deviceClientAppVersion',
  State: 'state',
  SupportLanguage: 'supportLanguage',
  UserProblemProblem: 'userProblemProblem',
  UserProblemFeature: 'userProblemFeature',
} as const

export type QueueStatsFilterTypeDefinitionKey =
  (typeof QueueStatsFilterTypeDefinitionKey)[keyof typeof QueueStatsFilterTypeDefinitionKey]
